import { JSX } from 'react';
import {
    List,
    TextField,
    Datagrid,
    SelectField,
    EditButton,
    ReferenceField
} from 'react-admin';
import { mysteryShopperTypes } from "../../defaults/defaults";

export const MiniGradesList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={ false }
        >
            <Datagrid bulkActionButtons={false} >
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="finalGrade" sx={ { textTransform: 'capitalize' } } />
                <ReferenceField source="mysteryShopperResult" reference="mystery_shopper_results">
                    <TextField source="id" />
                </ReferenceField>
                <ReferenceField source="complianceSnifferResult" reference="compliance_sniffer_results">
                    <TextField source="id" />
                </ReferenceField>
                <EditButton label="View" />
            </Datagrid>
        </List>
    );
}
